import { render, staticRenderFns } from "./FazerPedidoTuor.vue?vue&type=template&id=2ebfb5fe&scoped=true&"
import script from "./FazerPedidoTuor.vue?vue&type=script&lang=js&"
export * from "./FazerPedidoTuor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebfb5fe",
  null
  
)

export default component.exports